import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { withTranslation } from 'react-i18next';
import { actions as authActions } from '../../store/reducers/authUser';
import {
  actions as registrationActions,
  paymentPlans,
  paymentModes,
} from '../../store/reducers/registration';
import SlideBox from '../../components/slide-box';
import ApplyPromotion from '../../components/on-boarding/promo-code';
import PaymentPlan from '../../components/on-boarding/payment-plan';
import PaymentSummary from '../../components/on-boarding/payment-summary';
import User from '../../models/user';
import PaymentOption from '../../components/on-boarding/payment-option';
import './PaymentMethod.scss';
import { ContainerLoader } from '../../components/loader';
import { State } from '../../store/interfaces';
import { CheckboxInput } from '../../components/form-group/checkbox';
import ApplyReferral from '../../components/on-boarding/referral-apply-box';
import { ErrorResponse } from '../../store/reducers/error';


interface CustomState {
  referralCodeError: string;
}
interface CustomProps {
  isLoading: boolean;
  hasPromotion: boolean;
  addSummary?: (data: any) => void;
  user?: User;
  gotoNextBlock?: () => any;
  selectFullPayment?: () => any;
  selectStagePayment?: () => any;
  course: any;
  fullPaymentSelected: boolean;
  totalAmount?: number;
  totalForMilestones?: number;
  totalRtaForMilestones?: number;
  totalEdsForMilestones?: number;
  promotion?: any;
  summary: any;
  paymentMethod: paymentModes;
  selectPayAtEDC: () => void;
  selectPayOnline: () => void;
  courseType: string;
  milestones: any[];
  payingAmount: number;
  removePromoCode: () => void;
  completePayment: (
    milestones: any[],
    payingAmount: number,
    courseType: string,
    promotion: any,
    retryPayment: boolean,
    promoCode?: string,
    referralAmount?: number,
    referralList?: any,
    referralCode?: string,
    referralType?: string,
    isAdditionalPromotion?: boolean
  ) => void;
  OnlinePaymentStatus?: string;
  showPromoCodeBox?: boolean;
  promotions?: any[];
  promoCode?: string;
  classes?: string;
  onApply: (value: any) => void;
  logout: () => void;
  onReferralChange: (value: any) => void;
  hasReferral: boolean;
  onApplyReferral: (value: any, referralType: any) => void;
  onRemoveReferral: (value: any) => void;
  referralList?: any[];
  referralCode?: string;
  referralAmount?: number;
  referralType?: string;
  tokenBalanceAmount?: number;
  referralCodeError: string;
  formatedCourse?: any;
  formatedSummary?: any;
  totalForFormatedMilestones?: number;
  payingFormatedAmount?: number;
  isAllMilestonesSelected?: boolean;
}
class PaymentPlans extends Component<CustomProps, CustomState> {
  static defaultProps: Partial<CustomProps> = {
    summary: {},
    hasReferral: false,
  };

  constructor(props: CustomProps) {
    super(props);
    this.state = {
      referralCodeError: '',
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onApply = this.onApply.bind(this);
    this.onReferralChange = this.onReferralChange.bind(this);
  }

  translate = (key: string) => {
    const { t } = this.props as any; // t comes from withTranslation HOC
    return t(key);
  };

  async onSubmit() {
    document
      ?.getElementById('paymentPlans')
      ?.scrollIntoView({ behavior: 'smooth' });
    try {

      if (this.props.hasReferral && !this.props.referralCode) {
        this.setState({
          referralCodeError: this.translate('common.lblReferralCodeRequired'),
        });
        return;
      }
      if (this.props.addSummary) {
        this.props.addSummary({
          key: 'paymentplan',
          label: this.translate('common.lblYourChoosePaymentPlanAs'),
          value: this.props.fullPaymentSelected
            ? this.translate('common.lblFullPayment')
            : this.translate('common.lblStagePayment'),
        });
        this.props.addSummary({
          key: 'paymableamount',
          label: this.translate('common.lblAndAmountPayableIs'),
          value: `AED ${(this.props.totalAmount || 0).toFixed(2)}`,
        });
      }

      let isAdditionalPromotion = false;
      let payingAmount: number = this.props.payingAmount;
      if ((this.props.isAllMilestonesSelected || this.props.fullPaymentSelected) && this.props.formatedCourse && this.props.formatedSummary) {
        isAdditionalPromotion = true;
        payingAmount = this.props.payingFormatedAmount ?? payingAmount;
      }

      await this.props.completePayment(
        this.props.milestones,
        payingAmount,
        this.props.courseType,
        this.props.promotion,
        this.props.OnlinePaymentStatus === 'failed',
        this.props.promoCode,
        this.props.referralAmount,
        this.props.referralList,
        this.props.referralCode,
        this.props.referralType,
        isAdditionalPromotion
      );
      if (this.props.gotoNextBlock) this.props.gotoNextBlock();
    } catch (err) {
      const typedError = err as ErrorResponse;

      if (typedError.message === 'User has already done payment') {
        toastr.error(
          this.translate('common.lblError'),
          this.translate('common.lblUserHasAlreadyDonePaymentPleaseLoginAgain')
        );
        this.props.logout();
      } else {
        toastr.error(
          this.translate('common.lblError'),
          typedError.response.data.message
        );
      }
    }
  }

  onChange() {
    this.props.removePromoCode();
  }

  onApply(value: any) {
    this.props.onApply(value);
  }

  onReferralChange(value: any) {
    this.setState({ referralCodeError: '' });
    this.props.onReferralChange(value);
  }


  renderPromotionInput() {
    if (this.props.showPromoCodeBox) {
      return (
        <SlideBox
          showPromoCodeBox={this.props.showPromoCodeBox}
          promotions={this.props.promotions}
          promoCode={this.props.promoCode}
          onApply={this.onApply}
          classes={this.props.classes}
        />
      );
    }

    let totalDiscount = this.props.summary?.totalDiscount;
    if ((this.props.isAllMilestonesSelected || this.props.fullPaymentSelected) && this.props.formatedCourse && this.props.formatedSummary) {
      totalDiscount = this.props.formatedSummary?.totalDiscount;
    }


    return (
      <ApplyPromotion
        promotion={this.props.promotion}
        amount={totalDiscount}
        showRemoveButton={false} // {!this.props.hasPromotion}
        showPromoCodeBox={this.props.showPromoCodeBox}
        onChange={() => this.props.removePromoCode()}
      />
    );
  }

  renderReferralInput() {
    return (
      <div>
        <ApplyReferral
          promotion={this.props.promotion}
          amount={this.props.summary.totalDiscount}
          showRemoveButton
          showPromoCodeBox={this.props.showPromoCodeBox}
          referralApplyText={this.translate('common.lblApply')}
          course={this.props.course}
          referralCode={this.props.referralCode}
          onClick={(value, referralType) =>
            this.props.onApplyReferral(value, referralType)
          }
          onRemoveReferral={(value) => this.props.onRemoveReferral(value)}
          referralType={this.props.referralType}
          referralError={this.state.referralCodeError}
        />
      </div>
    );
  }



  renderPayOnlineMethod() {
    return (
      <div className="w-full mb-4 sm:mb-0">
        <PaymentOption
          onSelect={() => this.props.selectPayOnline()}
          id="pay-method-online"
          // disabled
          label={this.translate('common.lblPayOnline')}
          icon="icon-payonline"
          selected={this.props.paymentMethod === paymentModes.online}
        />
      </div>
    );
  }

  // eslint-disable-next-line class-methods-use-this
  renderPayAtECOMethod() {
    return (
      <div className="w-full">
        <PaymentOption
          onSelect={() => this.props.selectPayAtEDC()}
          id="pay-method-ecodrive"
          label={`${this.translate('common.lblPayAt')} ${
            process.env.REACT_APP_COMPANY
          }`}
          icon="ecodrive"
          selected={this.props.paymentMethod === paymentModes.edsCenter}
        />
      </div>
    );
  }

  renderPaymentMethods() {
    return (
      <div className="py-8">
        <p className="text-lg font-semibold pb-3.5 capitalize">
          {this.translate('dashboard.Choose_payment')}
        </p>
        <div className="grid grid-cols-2 gap-x-4 lg:gap-x-7">
          {this.renderPayOnlineMethod()}
          {this.renderPayAtECOMethod()}
        </div>
      </div>
    );
  }

  renderCompletePaymentButton() {
    const buttonText = this.props.isLoading
      ? this.translate('common.lblPleaseWait')
      : this.translate('dashboard.Complete_Payment');

    let isAdditionalPromotion = false;
    let payingAmount: number = this.props.payingAmount;
    if ((this.props.isAllMilestonesSelected || this.props.fullPaymentSelected) && this.props.formatedCourse && this.props.formatedSummary) {
      isAdditionalPromotion = true;
      payingAmount = this.props.payingFormatedAmount ?? payingAmount;
    }

    return (
      <button
        type="button"
        className="btn btn-primary w-full col-span-2 md:col-span-1"
        disabled={this.props.isLoading || !payingAmount || payingAmount <= 0}
        onClick={() => {
          document
            ?.getElementById('paymentPlans')
            ?.scrollIntoView({ behavior: 'smooth' });
          this.props.completePayment(
            this.props.milestones,
            payingAmount,
            this.props.courseType,
            this.props.promotion,
            this.props.OnlinePaymentStatus === 'failed',
            this.props.promoCode,
            this.props.referralAmount,
            this.props.referralList,
            this.props.referralCode,
            this.props.referralType,
            isAdditionalPromotion
          );
        }}
      >
        {buttonText}
      </button>
    );
  }

  renderContinueToPaymentButton() {

    let payingAmount: number = this.props.payingAmount;
    if ((this.props.isAllMilestonesSelected || this.props.fullPaymentSelected) && this.props.formatedCourse && this.props.formatedSummary) {
      payingAmount = this.props.payingFormatedAmount ?? payingAmount;
    }

    return (
      <button
        onClick={this.onSubmit}
        disabled={payingAmount <= 0}
        className="btn btn-primary w-full col-span-2 md:col-span-1"
      >
        {this.translate('dashboard.Proceed_Pay')}
      </button>
    );
  }

  render() {
    if (this.props.isLoading || !this.props.course) {
      return (
        <ContainerLoader
          height={500}
          text={this.translate('common.lblLoadingCourseStructure')}
        ></ContainerLoader>
      );
    }

    let courseData = this.props.course;
    let totalForMilestonesData = this.props.totalForMilestones;
    if(this.props.formatedCourse){
      courseData = this.props.formatedCourse;
    }
    if (this.props.isAllMilestonesSelected && this.props.formatedCourse?.milestones) {
      totalForMilestonesData = this.props.totalForFormatedMilestones;
    }

    let paymentSummary = this.props.summary;
    if ((this.props.isAllMilestonesSelected || this.props.fullPaymentSelected) && this.props.formatedCourse && this.props.formatedSummary) {
      paymentSummary = this.props.formatedSummary;
    }

    return (
      <div className="pt-5 sm:pt-7" id="paymentPlans">
        <div className="max-w-[658px]">
          <p className="text-sm font-medium mb-3">
            {this.translate('common.lblStarterPlanIsRightForYou')}
          </p>
          <PaymentPlan
            key="full-payment"
            id="full-payment"
            name="Full payment"
            description={
              courseData.amount.totalDiscount > 0
                ? `${this.translate('common.lblYouSave')} AED ${
                  courseData.amount.totalDiscount
                  }`
                : ''
            }
            totalAmount={
              courseData.amount.totalAmount -
              courseData.amount.totalDiscount
            }
            totalRtaAmount={courseData.amount.rta.totalAmount}
            totalEdsAmount={courseData.amount.drivingCenter.totalAmount}
            allowPartialPayment={false}
            selected={this.props.fullPaymentSelected}
            onSelect={this.props.selectFullPayment}
            primary
          />
          <PaymentPlan
            id="stage-payment"
            name={this.translate('common.lblChooseWhatYouWantToPay')}
            key="stage-payment"
            description={this.translate('common.lblYouCanPayForMultipleStages')}
            totalAmount={totalForMilestonesData}
            totalRtaAmount={this.props.totalRtaForMilestones}
            totalEdsAmount={this.props.totalEdsForMilestones}
            allowPartialPayment
            selected={!this.props.fullPaymentSelected}
            onSelect={this.props.selectStagePayment}
          />
          <div className="py-2">
            <p className="text-sm font-medium">
              {this.translate('dashboard.Promocodes')}
            </p>
            {this.renderPromotionInput()}
          </div>
          <div className="pt-3">
            <CheckboxInput
              key="do-you-have-referral"
              options={[
                true,
                this.translate('common.lblDoYouHaveAnyReferrals'),
              ]}
              onChange={(value) => this.onReferralChange(value)}
              default={this.props.hasReferral}
              gap="md"
            />
          </div>
          {this.props.hasReferral && (
            <div className="pb-5">
              <p className="mb-2 text-sm">
                {this.translate('common.lblReferralType')} *
              </p>
              {this.renderReferralInput()}
            </div>
          )}
          <PaymentSummary
            summary={paymentSummary}
            referralAmount={this.props.referralAmount}
            tokenBalanceAmount={this.props.tokenBalanceAmount}
          />
          {this.renderPaymentMethods()}
          <div className="grid grid-cols-2 gap-x-4 lg:gap-x-7 pt-1 pb-5">
            {this.props.paymentMethod === paymentModes.edsCenter &&
              this.renderCompletePaymentButton()}
            {this.props.paymentMethod === paymentModes.online &&
              this.renderContinueToPaymentButton()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: State) => ({
  isLoading: state.registration.isLoading,
  user: state.registration.user,
  course: state.registration.course,
  hasPromotion: state.registration.promotion != null,
  promotion: state.registration.promotion,
  summary: state.registration.summary,
  totalAmount:
    state.registration.summary.totalAmount +
    state.registration.summary.totalTax -
    state.registration.summary.totalDiscount,
  fullPaymentSelected:
    state.registration.paymentPlan === paymentPlans.fullPayment,
  isAllMilestonesSelected:
    state.registration.stagePayment.isAllMilestonesSelected,
  totalForMilestones:
    state.registration.stagePayment.summary.totalAmount -
    state.registration.stagePayment.summary.totalDiscount,
  totalRtaForMilestones:
    state.registration.stagePayment.summary.drivingCenter.totalAmount,
  totalEdsForMilestones:
    state.registration.stagePayment.summary.rta.totalAmount,
  courseType: state.registration.courseType as string,
  paymentMethod: state.registration.modeOfPayment,
  milestones:
    state.registration.course &&
    state.registration.paymentPlan === paymentPlans.fullPayment
      ? state.registration.course.milestones.map((ml: any) => ({ _id: ml._id }))
      : state.registration.stagePayment.milestones.map((ml: any) => ({
          _id: ml._id,
        })),
  payingAmount:
    state.registration.summary.totalAmount +
    state.registration.summary.totalTax -
    state.registration.summary.totalDiscount -
    (state.registration.summary.referralAmount || 0) -
    (state?.registration?.tokenBalanceAmount || 0),
  OnlinePaymentStatus: state.registration.onlinePaymentStatus,
  showPromoCodeBox: state.registration.showPromoCodeBox,
  classes: state.registration.showPromoCodeBox ? 'slideBox active' : 'slideBox',
  promotions: state.registration.promotions,
  promoCode: state.registration.promoCode,
  hasReferral: state.registration.hasReferral,
  referralAmount: state.registration?.referralAmount || 0,
  referralList: state.registration.referralList,
  referralCode: state.registration.referralCode,
  referralType: state.registration.referralType,
  tokenBalanceAmount: state?.registration?.tokenBalanceAmount || 0,
  formatedCourse:  state.registration.formatedCourse,
  formatedSummary:  state.registration.formatedSummary,
  totalForFormatedMilestones:
    (state.registration.stagePayment?.formatedSummary?.totalAmount || 0) -
    (state.registration.stagePayment?.formatedSummary?.totalDiscount || 0),
  payingFormatedAmount:
    (state.registration.formatedSummary?.totalAmount || 0) +
    (state.registration.formatedSummary?.totalTax || 0) -
    (state.registration.formatedSummary?.totalDiscount || 0) -
    (state.registration.formatedSummary?.referralAmount || 0) -
    (state?.registration?.tokenBalanceAmount || 0),
});

const mapDispatchToProps = (dispatch: any) => ({
  selectStagePayment: () =>
    dispatch(registrationActions.changePaymentPlan(paymentPlans.stagePayment)),
  selectFullPayment: () =>
    dispatch(registrationActions.changePaymentPlan(paymentPlans.fullPayment)),
  onMilestoneSelection: (milestone: any, selected: boolean) =>
    dispatch(registrationActions.selectMilestone(milestone, selected)),
  selectPayAtEDC: () =>
    dispatch(registrationActions.changePaymentMethod(paymentModes.edsCenter)),
  selectPayOnline: () =>
    dispatch(registrationActions.changePaymentMethod(paymentModes.online)),
  completePayment: (
    milestones: any[],
    amount: number,
    courseType: string,
    promotion: any,
    retryPayment: boolean,
    promoCode?: string,
    referralAmount?: number,
    referralList?: any,
    referralCode?: string,
    referralType?: string,
    isAdditionalPromotion?: boolean,
  ) =>
    dispatch(
      registrationActions.initiatePayment(
        milestones,
        amount,
        courseType,
        promotion,
        retryPayment,
        promoCode,
        referralAmount,
        referralList,
        referralCode,
        isAdditionalPromotion
      )
    ),
  removePromoCode: () => dispatch(registrationActions.clearPromoCode()),
  onApply: (promoCode: string) =>
    dispatch(registrationActions.applyPromoCode(promoCode)),
  logout: () => dispatch(authActions.logout()),

  onReferralChange: (selected: any) =>
    dispatch(registrationActions.showReferralBox(selected)),

  onApplyReferral: (referral: any, referralType: any) =>
    dispatch(registrationActions.applyReferral(referral, referralType)),
  onRemoveReferral: (referral: any) =>
    dispatch(registrationActions.removeReferral(referral)),
});

// PaymentPlans.propTypes = {
//   isLoading: PropTypes.bool,
//   hasPromotion: PropTypes.bool,
//   user: PropTypes.shape({}),
//   course: PropTypes.shape({
//     amount: PropTypes.shape({
//       totalAmount: PropTypes.number,
//       totalDiscount: PropTypes.number,
//       rta: PropTypes.shape({ totalAmount: PropTypes.number }),
//       drivingCenter: PropTypes.shape({ totalAmount: PropTypes.number }),
//       promotions: PropTypes.arrayOf(PropTypes.shape({})),
//     }),
//   }),
//   addSummary: PropTypes.func.isRequired,
//   gotoNextBlock: PropTypes.func.isRequired,
//   fullPaymentSelected: PropTypes.bool.isRequired,
//   totalAmount: PropTypes.number.isRequired,
//   totalForMilestones: PropTypes.number.isRequired,
//   totalRtaForMilestones: PropTypes.number.isRequired,
//   totalEdsForMilestones: PropTypes.number.isRequired,
//   onSubmit: PropTypes.func.isRequired,
//   selectFullPayment: PropTypes.func.isRequired,
//   selectStagePayment: PropTypes.func.isRequired,
//   summary: PropTypes.shape({
//     totalAmount: PropTypes.number,
//     totalTax: PropTypes.number,
//     totalDiscount: PropTypes.number,
//   }),
//   promotion: PropTypes.shape({}),
// };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(PaymentPlans));
